import { GetterTree } from 'vuex';
import { AuthState } from '@/modules/Auth/store/state';
import { RootState } from '@/plugins/store';
import jwtDecode from 'jwt-decode';
import { LoginResponse } from '@/models/LoginResponse';

export const getters: GetterTree<AuthState, RootState> = {
    getJwtToken(): string {
        return localStorage.getItem('token_portail_partenaire') || '';
    },
    getUserInformations(): LoginResponse {
        return jwtDecode(localStorage.getItem('token_portail_partenaire') ||'');
    },
    getUser(state): LoginResponse | null {
        return state.userInformations;
    },
    isOldLogin(state): boolean {
        return state.isOldLogin;
    }
};
